module.exports = __webpack_public_path__ + "img/baby-blue.84ba5e8b.svg";